import React from 'react';
import SingleVitamin from './SingleVitamin'
import '../App.css';

const Vitamins = ({ foodNutrients, 
    // visibility, 
    // setVisibility,
    query,
    setQuery, 
    // getQuery
 }) => {
    // console.log(foodNutrients)

    return (

        <div classame='vitamins-container' style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', position:'relative'}}>



            {foodNutrients.map((foodNutrient) => {
                const { id, name, image } = foodNutrient;
                return (
                    <>

                        <SingleVitamin 
                        foodNutrients={foodNutrients}
                         foodNutrient={foodNutrient} 
                         id={id} 
                         name={name}
                          image={image} 
                        //   visibility={visibility}
                        //   setVisibility={setVisibility}
                        // query={query}
                        // setQuery={setQuery}
                        // getQuery={getQuery}
                       

                          />


                    </>
                )
            }
            )

            }

        </div>

    )

}

export default Vitamins
